import React, { createContext, useContext, useEffect, useState } from 'react'
import API from '../../../../services/API'
import { Button, Divider, Stack, TextField, Typography } from '@mui/material'
import LetterIntro from './LetterIntro'
import CompanyObligations from './CompanyObligations'
import ClientObligations from './ClientObligations'
import ExclusivityClause from './ExclusivityClause'
import FailureToDeliver from './FailureToDeliver'
import CancellationTerms from './CancellationTerms'
import InvoiceTerms from './InvoiceTerms'
import { GlobalContext } from '../../../../App'

export const EngagementLetterContext = createContext()

const selects = [
  'wordings.engagementLetter.letterIntro',
  'wordings.engagementLetter.companyObligations',
  'wordings.engagementLetter.clientObligations',
  'wordings.engagementLetter.exclusivityClause',
  'wordings.engagementLetter.failureToDeliver',
  'wordings.engagementLetter.cancellationTerms',
  'wordings.engagementLetter.invoiceTerms',
]

const EngagementLetter = () => {
  const [engagementLetter, setEngagementLetter] = useState({
    letterIntro: '',
    companyObligations: [],
    clientObligations: [],
    exclusivityClause: '',
    failureToDeliver: '',
    cancellationTerms: '',
    invoiceTerms: '',
  })
  const { setToast } = useContext(GlobalContext)

  useEffect(() => {
    API.get(
      `/settings?select=${selects.map(encodeURIComponent).join(' ')}`
    ).then(
      (res) =>
        res.status === 200 &&
        setEngagementLetter(res.data.wordings.engagementLetter)
    )
  }, [])

  const submitChanges = () => {
    API.put('/site-config', {
      'wordings.engagementLetter': engagementLetter,
    }).then(
      (res) =>
        res.status === 200 && setToast({ message: 'Engagement Letter Updated' })
    )
  }

  return (
    <EngagementLetterContext.Provider
      value={{
        engagementLetter,
        setEngagementLetter,
      }}
    >
      <Stack gap={3} divider={<Divider />}>
        <Typography>
          This section allows you to control the wordings used in the Engagement
          Letter generated for your clients. <br/>You can use the{' '}
          <b>{"{{CLIENTNAME}}"}</b> and <b>{"{{ORGNAME}}"}</b> tags.
        </Typography>
        <LetterIntro />
        <CompanyObligations />
        <ClientObligations />
        <ExclusivityClause />
        <FailureToDeliver />
        <CancellationTerms />
        <InvoiceTerms />
        <Button
          onClick={submitChanges}
          color="success"
          fullWidth
          variant="contained"
        >
          Submit Changes
        </Button>
      </Stack>
    </EngagementLetterContext.Provider>
  )
}

export default EngagementLetter
